import { ITicketsInfo } from 'store/afterSales/types'

export const hasAnyTicket = (ticketsResponse: ITicketsInfo): boolean => {
  const processedTickets = [
    ticketsResponse.active,
    ticketsResponse.available,
    ticketsResponse.completed,
  ]

  const hasProcessedTickets = processedTickets.some((category) => category && category.length > 0)
  const hasProcessingTickets = Boolean(ticketsResponse.processing && ticketsResponse.processing > 0)
  const hasPaymentProcessingTickets = Boolean(
    ticketsResponse.paymentProcessing && ticketsResponse.paymentProcessing > 0,
  )

  return hasProcessedTickets || hasProcessingTickets || hasPaymentProcessingTickets
}
